import React, { useState } from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import NavMenu from './NavMenu';
import MobNav from './NavMenu/MobNav';

const { colors, spaces } = theme;

const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${colors.gray[200]};
  width: 100%;
  background: ${colors.white};
  position: fixed;
  top: 0;
  z-index: 20;
`;

const StyledHeaderContainer = styled.div`
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
`;

function Header({ headerRef }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  return (
    <StyledHeader ref={headerRef}>
      <StyledHeaderContainer>
        <NavMenu open={open} handleOpen={handleOpen} />
        <MobNav open={open} handleOpen={handleOpen} />
      </StyledHeaderContainer>
    </StyledHeader>
  );
}

export default Header;
